var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h2", [_vm._v(_vm._s(_vm.accessoryFeatures.title))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row", attrs: { id: "anchor-technical-sheet" } },
      [
        _vm.isFirstParty
          ? _vm._l(
              _vm.accessoryFeatures.technicalFeatures,
              function (feature, index) {
                return _c(
                  "div",
                  {
                    key: "technical-feature-" + index,
                    staticClass: "mb-2 mb-md-3",
                    class: index === 0 ? "col-12" : "col-12 col-md-6",
                  },
                  [
                    _c("p", { staticClass: "lead fw-bold mb-0" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(feature.title) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "text-mw standard text-break",
                      domProps: { innerHTML: _vm._s(feature.text) },
                    }),
                  ]
                )
              }
            )
          : [
              _c(
                "ul",
                { staticClass: "list-unstyled" },
                _vm._l(
                  _vm.accessoryFeatures.technicalFeatures,
                  function (feature, index) {
                    return _c("li", { key: index, staticClass: "list-item" }, [
                      _c("div", {
                        directives: [
                          {
                            name: "msh-html",
                            rawName: "v-msh-html",
                            value: feature.title,
                            expression: "feature.title",
                          },
                        ],
                        staticClass: "list-item-title",
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "msh-html",
                            rawName: "v-msh-html",
                            value: feature.text,
                            expression: "feature.text",
                          },
                        ],
                        staticClass: "list-item-text",
                      }),
                    ])
                  }
                ),
                0
              ),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }